module.exports = __webpack_public_path__ + "img/totalPerson.559f403a.png";